
import {
  Input,
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Form,
  Table,
  Popconfirm,
  notification,
  Select,
  Flex,
} from "antd";
import {
  CloudDownloadOutlined,
  CloudUploadOutlined,
  DeleteFilled,
  DeleteOutlined,
  FundOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "../Pages/CSS/DonnesBases.css";
import "../Pages/CSS/Traitement.css";
import { useEffect, useState } from "react";

import { JournalCentralService } from "../Services/JournalCentralService";
const { Option } = Select;
const { Title } = Typography;

const Budget = () => {
  const initialTableData = []; // Stocke les données initiales du tableau
  const initialNewPrestation = {
    codetype: "",
    libtype: "",
  };
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };

  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData); // Utilise initialTableData pour initialiser filteredData
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("4");
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(true);
  const [newPrestation, setNewPrestation] = useState(initialNewPrestation);
  const [selectedYear, setSelectedYear] = useState(getSelectedYear());
  const [years, setYears] = useState([]);
  const [selectedSubAccount, setSelectedSubAccount] = useState("Charges Techniques");

  const journalCentralService = new JournalCentralService();


  const fetchData = async () => {

    try {
      const yearsData = await journalCentralService.getComptaExercices();
      console.log("Années récupérées :", yearsData); // Vérifiez la structure des données
      setYears([...yearsData].sort((a, b) => b - a));
      const data = await journalCentralService.getBudjet(
        selectedYear,
        selectedMonth,
      );

      setTableData(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedYear, selectedMonth]);
  /*  useEffect(() => {
     
   }, []); */
  const handleYearChange = (value) => {
    setSelectedYear(value);
  };


  const handleUpdate = async () => { };
  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const createPrestation = async () => { };

  const handleSave = () => { };

  const handleDelete = async () => { };

  const handleRowClick = (record) => {
    setSelectedRowData(record); // Mettre à jour les données de la ligne sélectionnée
    setShowCreateForm(false);
  };

  const handleNew = () => {
    setSelectedRowData(null); // Réinitialiser les données sélectionnées
    setShowCreateForm(true); // Afficher le formulaire de création lors du clic sur "Nouveau"
  };

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Met à jour les données filtrées
  };



  const handleSubAccountChange = (value) => {
    setSelectedSubAccount(value);
  };



  const monthOptions = [
    { value: "00", label: "Mois" },
    { value: "1", label: "Janvier" },
    { value: "2", label: "Février" },
    { value: "3", label: "Mars" },
    { value: "4", label: "Avril" },
    { value: "5", label: "Mai" },
    { value: "6", label: "Juin" },
    { value: "7", label: "Juillet" },
    { value: "8", label: "Août" },
    { value: "9", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
  ];

  function formatNumber(number) {
    const num = Number(number);
    if (isNaN(num)) {
      return "0";
    }

    return new Intl.NumberFormat("fr-FR").format(num);
  }

  const columns = [
    {
      title: "Compte",
      dataIndex: "compte",
      key: "compte",
      align: "center",
      sorter: (a, b) => {
        if (!a.compte && b.compte) return 1;
        if (a.compte && !b.compte) return -1;
        if (!a.compte && !b.compte) return 0;
        return a.compte.localeCompare(b.compte);
      },
    },
    {
      title: "Libellé",
      dataIndex: "libtype",
      key: "libtype",
      align: "center",
      sorter: (a, b) => {
        if (!a.libtype && b.libtype) return 1;
        if (a.libtype && !b.libtype) return -1;
        if (!a.libtype && !b.libtype) return 0;
        return a.libtype.localeCompare(b.libtype);
      },
    },
    {
      title: "Solde",
      dataIndex: "solde",
      key: "solde",
      align: "right",
      sorter: (a, b) => (a.solde ?? 0) - (b.solde ?? 0),
      //render: (text) => <div>{text ? parseFloat(text).toLocaleString() : ""}</div>,
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
    {
      title: "Budget",
      dataIndex: "budget",
      key: "budget",
      align: "right",
      sorter: (a, b) => (a.budget ?? 0) - (b.budget ?? 0),
      render: (text) => <div>{text ? parseFloat(text).toLocaleString() : ""}</div>,
    },
    {
      title: "% Réal.",
      dataIndex: "percent_realized",
      key: "percent_realized",
      align: "right",
      sorter: (a, b) => (a.percent_realized ?? 0) - (b.percent_realized ?? 0),
      render: (text) => <div>{text ? `${parseFloat(text).toFixed(2)} %` : ""}</div>,
    },
    {
      title: "Ecart",
      dataIndex: "ecart",
      key: "ecart",
      align: "right",
      sorter: (a, b) => (a.ecart ?? 0) - (b.ecart ?? 0),
      render: (text) => <div>{text ? parseFloat(text).toLocaleString() : ""}</div>,
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      className: "small-cell",
      align: "center",
      ellipsis: true,
      width: "2%",
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record.codetype)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];


  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <FundOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
            margin: 0,
          }}
        >
          Prévision budget
        </span>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={18}>
          <Row gutter={[16, 16]}>
            <Col xs={24} xl={8}>
              <Input
                className="search-input-highlight"
                placeholder="Rechercher..."
                allowClear
                prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                style={{ width: "100%", marginTop: "25px" }}
                onChange={(e) => handleSearch(e.target.value)}
                onPressEnter={(e) => handleSearch(e.target.value)}
              />
            </Col>
            <Col
              xs={24}
              xl={16}
              style={{
                display: "flex",
                justifyContent: "end",
                marginBottom: 14,
              }}
            >
              <Row gutter={16}>
                <Space wrap>
                  <Col xs={24} sm={12} xl={8}>
                    <Space direction="vertical" style={{ textAlign: "left" }}>
                      <label /* style={{fontSize:"14px"}} */>Année</label>
                      <Select
                        className="select-colored-accent"
                        style={{
                          width: 90,
                          "--select-accent": "#1890ff",
                          "--select-accent-bg": "#e6f4ff",
                          "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                        }}
                        onChange={handleYearChange}
                        value={selectedYear}
                      >
                        {years.map((year) => (
                          <Option key={year} value={year}>
                            {year}
                          </Option>
                        ))}
                      </Select>
                    </Space>
                  </Col>
                  <Col xs={24} sm={12} xl={8}>
                    <Space direction="vertical" style={{ textAlign: "left" }}>
                      <label></label>
                      <Select
                        className="select-colored-accent"
                        style={{
                          width: 140,
                          "--select-accent": "#722ed1",
                          "--select-accent-bg": "#f9f0ff",
                          "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                        }}
                        onChange={setSelectedMonth}
                        value={selectedMonth}
                      >
                        {monthOptions.map((month) => (
                          <Option key={month.value} value={month.value}>
                            {month.label}
                          </Option>
                        ))}
                      </Select>
                    </Space>
                  </Col>
                  <Col xs={24} sm={24} xl={8}>
                    <Space direction="vertical" style={{ textAlign: "left" }}>
                      <label>Sous Compte</label>
                      <Select
                        className="select-colored-accent"
                        style={{
                          width: 300,
                          "--select-accent": "#52c41a",
                          "--select-accent-bg": "#f6ffed",
                          "--select-accent-shadow": "rgba(82, 196, 26, 0.25)",
                        }}
                        onChange={handleSubAccountChange}
                        value={selectedSubAccount}
                      >
                        <Select.Option value="Tous les comptes">Tous les comptes</Select.Option>
                        <Select.Option value="Charges Techniques">Charges Techniques</Select.Option>
                        <Select.Option value="Charges Non Techniques">Charges Non Techniques</Select.Option>
                        <Select.Option value="Produits Techniques">Produits Techniques</Select.Option>
                      </Select>
                    </Space>
                  </Col>
                </Space>
              </Row>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={24}
              style={{
                display: "flex",
                justifyContent: "end",
                marginBottom: 12,
              }}
            >
              <Flex wrap="wrap" gap="small">
                <Button icon={<CloudUploadOutlined />} className="buttonImport">Import</Button>
                <Button
                  // disabled={isButtonDisabled}
                  className="buttonClose"
                  // onClick={handleDelete}
                  icon={<DeleteOutlined />}
                >
                  Supprimer
                </Button>
                <Button icon={<CloudDownloadOutlined />} className="buttonExport">Export</Button>

                <Button className="buttonRefresh">Actualiser</Button>
              </Flex>
            </Col>
          </Row>
          <Table
            className="custom-header1-table"
            showSorterTooltip={false}
            bordered
            columns={columns}
            dataSource={filteredData}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            loading={loading}
          />
        </Col>

        <Col xs={24} xl={6}>
          {showCreateForm ? (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title
                    level={4}
                    style={{ margin: 0, marginLeft: "15px", color: "#ffffff" }}
                  >
                    Nouvelle Budget
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="Libellé">
                  <Input
                    placeholder="libellé ..."
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        codetype: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Compte">
                  <Input
                    placeholder="compte ..."
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        compte: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Budget">
                  <Input
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        budget: e.target.value,
                      })
                    }
                  />
                </Form.Item>

                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      onClick={() => setShowCreateForm(false)}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleSave}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Enregistrer
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          ) : (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0, color: "#ffffff" }}>
                    {" "}
                    Modification Budget
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="Libellé">
                  <Input
                    placeholder="libellé..."
                    value={selectedRowData ? selectedRowData.libtype : ""}
                    onChange={(e) =>
                      setSelectedRowData({
                        ...selectedRowData,
                        libtype: e.target.value,
                      })
                    }
                  />
                  <Form.Item label="Compte">
                    <Input
                      value={selectedRowData ? selectedRowData.compte : ""}
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          compte: e.target.value,
                        })
                      }
                    />
                  </Form.Item>
                  <Form.Item label="Budget">
                    <Input
                      value={selectedRowData ? selectedRowData.budget : ""}
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          budget: e.target.value,
                        })
                      }
                    />
                  </Form.Item>
                </Form.Item>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      type="primary"
                      onClick={handleNew}
                      style={{
                        backgroundColor: "transparent",
                        color: "#010f1c",
                        borderColor: "#010f1c",
                      }}
                    >
                      Nouveau
                    </Button>
                    <Button
                      onClick={handleUpdate}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Modifier
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Budget;
